/** Perspective identifiers — leaf module (no imports) for routes and saved search state. */

export const PERSPECTIVE_IDS = {
  COMMUNITY: "community",
  REAL_ESTATE: "realEstate",
  WEATHER: "weather",
  CULTURE: "culture",
  FOOD: "food",
  GOVERNMENT: "government",
  TRANSPORT: "transport",
  AUTOMOTIVE: "automotive",
  DATA: "data",
  ADMINISTRATION: "administration",
  CLIENT_VIEWS: "clientViews",
  CRM: "crm",
};

export const DEFAULT_PERSPECTIVE_ID = PERSPECTIVE_IDS.COMMUNITY;
